module.exports = __webpack_public_path__ + "static/media/myco.7bfc62fd.png";